import {lazy} from '@/common/utils/lazy'
import {FeatureEnabledService, makeFeatureEnabledService} from '@/common/services/FlagService'
import {AdminStatesConstant} from '@/branchmanager/app/constant/AdminStatesConstant'

export const getManagementAppsFeatureEnabledService = lazy<FeatureEnabledService<string>>(() => {
  return makeFeatureEnabledService(
    {
      'oa-membership-eligibility': [AdminStatesConstant.CU_MEMBERSHIP_ELEGIBILITY.STATE],
      'oa-alloy-journeys': [AdminStatesConstant.JOURNEYS.STATE],
      'oa-applicant-review': [AdminStatesConstant.APPLICANT_REVIEW.STATE],
      'oa-bsa-defender': [AdminStatesConstant.BSA_DueDiligence.STATE],
    },
    false
  )
})
